import { ICardType } from '@introspection/index';
import { get, matching, mod } from 'shades';

export const matchingId = (id: string) => matching<{ id?: string }>({ id });
const insertionSort = (arr) => {
  for (let i = 1; i < arr.length; i++) {
    const key = arr[i];
    let j = i - 1;
    while (j >= 0 && arr[j].order > key.order) {
      arr[j + 1] = arr[j];
      j--;
    }
    arr[j + 1] = key;
  }
  return arr;
};

/* getProject.boards */
export const modCards = (boardId: string, columnId: string) => (callback: (cards: ICardType[]) => ICardType[]) =>
  mod('columns', matchingId(columnId), 'cards')(callback);

/* getProject.boards */
export const getCard = (columnId: string, cardId: string) =>
  get('columns', matchingId(columnId), 'cards', matchingId(cardId));

export const modCard =
  (boardId: string, columnId: string, cardId: string) => (callback: (card: ICardType) => ICardType) =>
    mod('columns', matchingId(columnId), 'cards', matchingId(cardId))(callback);

export const addCardToState = (boardId: string, columnId: string) => (card: ICardType) =>
  modCards(boardId, columnId)((cards) => insertionSort([...cards, card]));

export const removeCardFromState = (boardId: string, columnId: string) => (card: ICardType) =>
  modCards(boardId, columnId)((cards) => insertionSort(cards.filter((c) => c.id !== card.id)));
